import { render } from "./BrandPortfolioParentSpendCell.vue?vue&type=template&id=7c632402&scoped=true"
import script from "./BrandPortfolioParentSpendCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioParentSpendCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioParentSpendCell.vue?vue&type=style&index=0&id=7c632402&scoped=true&lang=scss"
import "./BrandPortfolioParentSpendCell.vue?vue&type=style&index=1&id=7c632402&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c632402"]])

export default __exports__